// extracted by mini-css-extract-plugin
module.exports = {"rich-text-block":"rich-text_rich-text-block__Ax0Qp","rich-text-table-block":"rich-text_rich-text-table-block__myt09","rich-text-table":"rich-text_rich-text-table__15iTR"};